import * as types from './mutations-types';

export const mutations = {
  [types.SET_DISCLAIMER](state) {
    state.disclaimer = true;
    localStorage.setItem('disclaimer', true);
  },
  [types.CLEAR_DISCLAIMER](state) {
    localStorage.removeItem('disclaimer');
    state.discalimer = false;
  },
};
